const space = 'mainFrame';

export const SET_SUB_PROJECT_PATH = `${space}/SET_SUB_PROJECT_PATH`;
export const SET_MENUS_DISPLAY_STATE = `${space}/SET_MENUS_DISPLAY_STATE`;
export const ERROR_COMPLETE = `${space}/ERROR_COMPLETE`;
export const INIT_COMPLETE = `${space}/INIT_COMPLETE`;
export const SET_BREADCRUMBS = `${space}/SET_BREADCRUMBS`;
export const SET_USERCOLLECTIONMENUS = `${space}/SET_USERCOLLECTIONMENUS`;
export const ADD_USERCOLLECTIONMENU = `${space}/ADD_USERCOLLECTIONMENU`;